<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{cvCardTitle}}</h4>
          </template>
          <template v-slot:body>
            <p v-show="!propOpenedInModal">{{cvCardSubHeader}}</p>
            <form action="#" v-if="vmGPathSkillFormData && Object.keys(vmGPathSkillFormData).length > 0">
              <div class="form-row">
              <div class="col-md-12 mb-3">
                  <label for="validationname">
                    {{cvNameLabel}}</label
                  >
                  <input
                    v-model="vmGPathSkillFormData.name"
                    type="text"
                    class="form-control"
                    required
                  />
              </div>
                <div class="col-md-12 mb-3">
                  <label for="validationdescription">
                    {{cvDescriptionLabel}}</label
                  >
                  <textarea
                    v-model="vmGPathSkillFormData.description"
                    type="text"
                    class="form-control textarea"
                    required ></textarea>
              </div>
                <div class="col-md-12 mb-3">
                  <label for="validationimage">
                    {{cvImageLabel}}</label
                  >
                  <input
                    v-model="vmGPathSkillFormData.image"
                    type="text"
                    class="form-control"
                    required
                  />
              </div>
                <div class="col-md-12 mb-3">
                  <label for="validationcolor_code">
                    {{cvColorCodeLabel}}</label
                  >
                  <input
                    v-model="vmGPathSkillFormData.color_code"
                    type="text"
                    class="form-control"
                    required
                  />
              </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button type="button" class="btn btn-primary" @click="gpath_skillEdit()">{{cvSubmitBtn}}</button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { GPathSkills } from "../../../FackApi/api/GPathSkill"
import ApiResponse from "../../../Utils/apiResponse"
import userPermission from "../../../Utils/user_permission.js"

export default {
  name: "GPathSkillEdit",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propGPathSkillObj: {
      type: Object,
      default: function () {
        return {
          "name": "",
          "description": "",
          "image": "",
          "color_code": ""
        }
      }
    }
  },
  data () {
    return {
      apiName: "gpath_skills_edit",
      cvCardTitle: "Edit GPaths Skill",
      cvCardSubHeader: "Edit GPaths Skill",
      cvSubmitBtn: "Edit",
      cvNameLabel: "name",
      cvDescriptionLabel: "description",
      cvImageLabel: "image",
      cvColorCodeLabel: "color code",
      showToast: false,
      cvLoadingStatus: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "GPathSkill Edit Response",
      vmGPathSkillFormData: {}
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    this.gpath_skillView()
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmGPathSkillFormData) {
          if (!this.vmGPathSkillFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * gpath_skillView
     */
    async gpath_skillView () {
      try {
        if (this.propOpenedInModal) {
          this.vmGPathSkillFormData = this.propGPathSkillObj
        }
        else {
          let gpathSkillId = this.$route.params.gps_id
          let gpathSkillViewResp = await GPathSkills.gpath_skillView(this, gpathSkillId)

          if (gpathSkillViewResp && gpathSkillViewResp.resp_status) {
            this.vmGPathSkillFormData = gpathSkillViewResp.resp_data.data
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_skillView() and Exception:", err.message)
      }
    },
    /**
     * gpath_skillEdit
     */
    async gpath_skillEdit () {
      try {
        // if (!this.validate()) {
        //   return false
        // }
        this.cvLoadingStatus = true
        let gpathSkillAddResp = await GPathSkills.gpath_skillEdit(this, this.vmGPathSkillFormData)
        await ApiResponse.responseMessageDisplay(this, gpathSkillAddResp)

        if (gpathSkillAddResp && !gpathSkillAddResp.resp_status) {
          return false
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseGPathSkillEditModal", this.vmGPathSkillFormData)
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_skillEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
<style scoped>
 textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
